import React from 'react';
import { Row, Col, Card } from 'antd';
import ReactECharts from 'echarts-for-react';
import USMapChart from '../../../Charts/USMapChart';
import { getTrendOption, getHourOption, getWeekOption, getGeoOption } from '../../../../pages/DataAnalysis/components/chartConfig';

interface AnalysisChartsProps {
    trendData: any[];
    distData: any;
    geoData: any;
    granularity: 'day' | 'week' | 'month';
}

export const AnalysisCharts: React.FC<AnalysisChartsProps> = ({ trendData, distData, geoData, granularity }) => {
    return (
        <Row gutter={16}>
            <Col span={24} style={{ marginBottom: 16 }}>
                <Card size="small" title="销售趋势 (Sales Trend)">
                    <ReactECharts option={getTrendOption(trendData, granularity)} style={{ height: 350 }} />
                </Card>
            </Col>
            <Col span={12} style={{ marginBottom: 16 }}>
                <Card size="small" title="24小时分布 (Hourly Distribution)">
                    <ReactECharts option={getHourOption(distData)} style={{ height: 300 }} />
                </Card>
            </Col>
            <Col span={12} style={{ marginBottom: 16 }}>
                <Card size="small" title="周分布 (Weekly Distribution)">
                    <ReactECharts option={getWeekOption(distData)} style={{ height: 300 }} />
                </Card>
            </Col>
            <Col span={24} style={{ marginBottom: 16 }}>
                <Card size="small" title="地理分布 (Geographic Distribution)">
                    <Row gutter={16}>
                        <Col span={14}>
                            <USMapChart data={geoData?.states || []} country={geoData?.country || 'US'} />
                        </Col>
                        <Col span={10}>
                            <ReactECharts option={getGeoOption(geoData)} style={{ height: 400 }} />
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    );
};
